module.exports = __webpack_public_path__ + "static/media/youtube.6d62b912.svg";